import { render, staticRenderFns } from "./ReviewCustomerGridComponent.vue?vue&type=template&id=afe7a548&scoped=true&"
import script from "./ReviewCustomerGridComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewCustomerGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe7a548",
  null
  
)

export default component.exports